import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalService } from 'app/modal/modal.service';
import * as Models from 'app/core/models';
import { LoginModalComponent } from 'app/shared/login/loginModal.component';
import { SignupModalComponent } from 'app/shared/signup/signupModal.component';
import { ForgotPasswordModalComponent } from 'app/shared/forgotPassword/forgotPasswordModal.component';
import { EmailConfirmModalComponent } from 'app/shared/emailConfirm/emailConfirm.component';
import { ResetPasswordModalComponent } from 'app/shared/resetPassword/resetPasswordModal.component';
import { MediaUploadModalComponent } from 'app/shared/mediaUploadModal/mediaUploadModal.component';
import { CompleteProcessModalComponent } from 'app/shared/completeProcessModal/completeProcessModal.component';
import { PublishProcessModalComponent } from 'app/shared/publishProcessModal/publishProcessModal.component';
import { ContactCreatorModalComponent } from 'app/shared/contactCreatorModal/contactCreatorModal.component';
import { ConfirmationModalComponent } from 'app/shared/confirmationModal/confirmationModal.component';

@Component({
    selector: 'app-modal-manager',
    templateUrl: './modalManager.component.html',
    styleUrls: ['./modalManager.component.scss']
})
export class ModalManagerComponent implements OnInit {

    modalList: Models.ModalItem[] = [];
    currentModals: Models.ModalItem[] = [];

    @ViewChild(LoginModalComponent) loginModal: LoginModalComponent;
    @ViewChild(SignupModalComponent) signupModal: SignupModalComponent;
    @ViewChild(ForgotPasswordModalComponent) forgotpasswordModal: ForgotPasswordModalComponent;
    @ViewChild(EmailConfirmModalComponent) emailConfirmModal: EmailConfirmModalComponent;
    @ViewChild(ResetPasswordModalComponent) resetPasswordConfirmModal: ResetPasswordModalComponent;
    @ViewChild(MediaUploadModalComponent) mediaUploadModalComponent: ResetPasswordModalComponent;
    @ViewChild(CompleteProcessModalComponent) completeProcessModalComponent: CompleteProcessModalComponent;
    @ViewChild(PublishProcessModalComponent) publishProcessModalComponent: PublishProcessModalComponent;
    @ViewChild(ContactCreatorModalComponent) contactCreatorModalComponent: ContactCreatorModalComponent;
    @ViewChild(ConfirmationModalComponent) confirmationModalComponent: ContactCreatorModalComponent;

    constructor(private modalService: ModalService) {
        modalService.command$.subscribe(data => {
            this.manageAction(data);
        });
    }

    ngOnInit() {

        this.modalList.push({ modalType: Models.ModalType.SIGN_UP, contentModal: this.signupModal });
        this.modalList.push({ modalType: Models.ModalType.LOGIN, contentModal: this.loginModal });
        this.modalList.push({ modalType: Models.ModalType.FORGOT_PASSWORD, contentModal: this.forgotpasswordModal });
        this.modalList.push({ modalType: Models.ModalType.CONFIRM_EMAIL, contentModal: this.emailConfirmModal });
        this.modalList.push({ modalType: Models.ModalType.RESET_PASSWORD, contentModal: this.resetPasswordConfirmModal });
        this.modalList.push({ modalType: Models.ModalType.MEDIA_UPLOAD, contentModal: this.mediaUploadModalComponent });
        this.modalList.push({ modalType: Models.ModalType.PROCESS_COMPLETE, contentModal: this.completeProcessModalComponent });
        this.modalList.push({ modalType: Models.ModalType.PROCESS_PUBLISH, contentModal: this.publishProcessModalComponent });
        this.modalList.push({ modalType: Models.ModalType.CONTACT_CREATOR, contentModal: this.contactCreatorModalComponent });
        this.modalList.push({ modalType: Models.ModalType.CONFIRMATION, contentModal: this.confirmationModalComponent });
    }

    private manageAction(context: Models.ModalContext) {
        const index: number = this.currentModals.findIndex(x => x.modalType === context.modalType);
        if (context.modalAction === Models.ModalAction.CLOSE) {
            if (index > -1) {
                this.currentModals[index].contentModal.closeModal();
                this.currentModals.splice(index, 1);
            } else {
              return;
            }
        } else {
            if (!context.leaveOthers && this.currentModals != null && this.currentModals.length > 0) {
                this.currentModals.forEach(x => {
                    x.contentModal.closeModal();
                });
                this.currentModals = [];
            }

            const askedModal: Models.ModalItem = this.modalList.find(x => x.modalType === context.modalType);
            askedModal.contentModal.openModal(context.parameters);
            if (index < 0) {
              this.currentModals.push(askedModal);
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/modal/modalManager.component.ts